// document.addEventListener("DOMContentLoaded", function () {

//   if (window.location.pathname !== "/pages/never-miss-a-special-day") {
//     return;
//   }

//   const params = new URLSearchParams(window.location.search);
//   const email = params.get("email");
//   console.log(email, 'email here...')
//   if (!email) return;

//   setTimeout(() => {
//     const formEmbed = document.querySelector("shopify-forms-embed");
//     if (!formEmbed) return;

//     const shadowRoot = formEmbed.shadowRoot;
//     if (!shadowRoot) return;

//     const emailInput = shadowRoot.querySelector("#email");
//     if (emailInput) {
//       emailInput.value = email;
//       emailInput.dispatchEvent(new Event("input", { bubbles: true }));
//     }

//   }, 3600);

  

// });


// -----------------------------

document.addEventListener("DOMContentLoaded", function () {

  if (window.location.pathname !== "/pages/never-miss-a-special-day") {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const email = params.get("email");
  console.log(email, 'email...')
  if (!email) return;

  setTimeout(() => {
    const formEmbed = document.querySelector("shopify-forms-embed");
    console.log(formEmbed, 'form embed4....')

    if (!formEmbed) return;

    const shadowRoot = formEmbed.shadowRoot;
    if (!shadowRoot) return;

    const emailInput = shadowRoot.querySelector("#email");

    if (emailInput) {
      emailInput.value = email;
      emailInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

  }, 4000);
  
});

function waitForEmbed() {
  const embed = document.querySelector("shopify-forms-embed");

  if (embed && embed.shadowRoot) {
    applyLayout();
  } else {
    requestAnimationFrame(waitForEmbed);
  }
}

function applyLayout() {
  const embed = document.querySelector("shopify-forms-embed");
  if (!embed || !embed.shadowRoot) return;

  const shadow = embed.shadowRoot;

  if (shadow.querySelector("#custom-shadow-style")) return;

  const style = document.createElement("style");
  style.id = "custom-shadow-style";
  style.textContent = `

  /* ============================= */
  /* MOBILE FIRST RESET           */
  /* ============================= */

  ._formBannerHeading_z5ku3_9 {
    justify-content: center !important;
    font-family: var(--font-body-brand) !important;
  }

  @media (min-width: 769px) {

    :host {
      --container-max-w: 100% !important;
      --inline-container-max-width: 100% !important;
    }

    /* ============================= */
    /* MAIN GRID                    */
    /* ============================= */

    ._formFieldset_cit2d_82 {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px !important;
      width: 100% !important;
    }

    /* ============================= */
    /* GRID POSITION CONTROL        */
    /* ============================= */

    ._formFieldset_cit2d_82 > *:nth-child(1){
      display: none;
    }

    ._formFieldset_cit2d_82 > *:nth-child(2),
    ._formFieldset_cit2d_82 > *:nth-child(3) {
      grid-column: span 1 !important;
    }
    ._formFieldset_cit2d_82 > *:nth-child(5),
    ._formFieldset_cit2d_82 > *:nth-child(6) {
      grid-column: span 1 !important;
    }

    ._formFieldset_cit2d_82 > *:nth-child(4) {
      grid-column: span 2 !important;
    }

    ._formFieldContainer_1mxsl_5 {
      align-self: end;
    }

    ._formFieldset_cit2d_82 > *:nth-child(7),
    ._formFieldset_cit2d_82 > *:nth-child(8) {
      grid-column: span 1 !important;
    }
    

    ._formFieldset_cit2d_82 > *:nth-child(9) {
      grid-column: span 2 !important;
    }

    ._formFieldset_cit2d_82 > *:nth-child(10),
    ._formFieldset_cit2d_82 > *:nth-child(11) {
      grid-column: span 1 !important;
    }

    // ._formFieldset_cit2d_82 > *:nth-child(12),
    // ._formFieldset_cit2d_82 > *:nth-child(13) {
    //   grid-column: span 1 !important;
    // }

    // /* Submit Button */
    //  {
    //   grid-column: span 2 !important;
    // }

    // /* Disclaimer */
    // ._formFieldset_cit2d_82 > *:nth-child(13) {
    //   grid-column: span 2 !important;
    // }

    /* ============================= */
    /* DATE INNER GRID              */
    /* ============================= */

    ._dateFieldContainer_rzr7e_5 {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
    }

    /* ============================= */
    /* INPUT CLEAN DESIGN           */
    /* ============================= */

    ._formInputField_nag3b_7 {
      border-radius: 0px !important;
      border: 0.5px solid black !important;
      width: 100% !important;
      box-sizing: border-box !important;
      box-shadow: none !important;
  }

    ._formInputField_nag3b_7:focus {
      outline: none !important;
      border-color: #000 !important;
    }

    input._formInputField_nag3b_7:focus-visible {
      box-shadow: unset !important;
    }

    /* ============================= */
    /* SUBMIT BUTTON                */
    /* ============================= */

    button._formSubmitButton_cit2d_96 {
      grid-column: span 2 !important;
      width: 500px !important;
      max-width: 100% !important;
      margin: 2px auto 0 auto !important;
      padding: 16px !important;
      font-weight: 600 !important;
      font-size: 15px !important;
      border-radius: 0px !important;
      cursor: pointer !important;
      transition: opacity 0.2s ease !important;
    }

    ._formSubmitButton_cit2d_96:hover {
      opacity: 0.9 !important;
    }

    /* Center disclaimer text */

    ._formDisclaimer_cit2d_38 {
      grid-column: span 2 !important;
      text-align: center !important;
      margin-top: 12px !important;
    }

    section._formHeader_cit2d_24 {
      text-align: center !important;
    }

    ._formContainer_1q1d2_30._tight_1q1d2_271 {
      padding: 60px 20px !important;
    }

    ._formBannerContainer_z5ku3_1 {
      text-align: center !important;
      max-width: 600px !important;
      margin: 0 auto !important;
    }

    ._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 {
      font-family: var(--font-body-brand);
      font-size: 18px !important;
      line-height: 1.6 !important;
      color: #444 !important;
    }
  }


  /* ============================= */
  /* MOBILE                       */
  /* ============================= */

  @media (max-width: 768px) {

  ._formInputField_nag3b_7 {
      border-radius: 0px !important;
      border: 1px solid black !important;
      width: 100% !important;
      box-sizing: border-box !important;
      box-shadow: none !important;
  }

    input._formInputField_nag3b_7:focus-visible {
      box-shadow: unset !important;
    }

    button._formSubmitButton_cit2d_96{
      border-radius: 0px !important;
    }
  }

  form._formFieldset_cit2d_82{
    padding: 5px 0 !important;
    
  }
  `;

  shadow.appendChild(style);
}

waitForEmbed();
const block = document.getElementById(
  "shopify-block-AQTVXS1lUVTJ3TlVpc__cd180c07-fd57-42be-8312-f1a62a56d25b"
);

if (block) {
  block.classList.add("grid-container");
}

window.initializeProductGallery = function () {

    const mainSliderEl = document.querySelector('.x-product-main-slider');
    const thumbSliderEl = document.querySelector('.x-product-thumb-slider');

    // Only the main slider is required — the thumb slider only exists in
    // the DOM when a product has more than one image (see product.liquid,
    // `{% if product.images.size > 1 %}`). Requiring both meant the main
    // slider — and therefore the whole gallery — never initialized at all
    // for any single-image product.
    if (!mainSliderEl) return;

    /*
    -----------------------------------
    DESTROY OLD SWIPERS
    -----------------------------------
    */

    if (mainSliderEl.swiper) {
        mainSliderEl.swiper.destroy(true, true);
    }

    if (thumbSliderEl && thumbSliderEl.swiper) {
        thumbSliderEl.swiper.destroy(true, true);
    }

    /*
    -----------------------------------
    THUMB SLIDER (only when it exists)
    -----------------------------------
    */

    let thumbSwiper = null;

    if (thumbSliderEl) {
        thumbSwiper = new Swiper('.x-product-thumb-slider', {
            slidesPerView: 4,
            spaceBetween: 8,
            watchSlidesProgress: true,

            navigation: {
                nextEl: '.x-product-thumb-next',
                prevEl: '.x-product-thumb-prev',
            },

            breakpoints: {
                320: {
                    slidesPerView: 4,
                },

                768: {
                    slidesPerView: 4,
                }
            }
        });
    }

    /*
    -----------------------------------
    MAIN SLIDER
    -----------------------------------
    */

    const mainSwiper = new Swiper('.x-product-main-slider', {

        slidesPerView: 1,
        spaceBetween: 10,

        navigation: {
            nextEl: '.x-product-main-next',
            prevEl: '.x-product-main-prev',
        },

        thumbs: thumbSwiper ? {
            swiper: thumbSwiper,
        } : undefined
    });

    /*
  -----------------------------------
  SET ACTIVE VARIANT IMAGE
  -----------------------------------
  */

  // const currentVariantId =
  // document.querySelector('select[name="id"]')?.value ||
  // document.querySelector('input[name="id"]')?.value;

  const currentVariantId =
document.querySelector('input[name="id"]')?.value;

  if (currentVariantId && window.productVariants) {

      const currentVariant = window.productVariants.find(
          variant => String(variant.id) === String(currentVariantId)
      );

if (currentVariant?.featured_image) {

    const mediaId =
    currentVariant.featured_image.id;

    let imageIndex = 0;

    document
    .querySelectorAll('.x-product-main-slider .swiper-slide')
    .forEach((slide, index) => {

        if (
            String(slide.dataset.mediaId) ===
            String(mediaId)
        ) {
            imageIndex = index;
        }

    });

    mainSwiper.slideTo(imageIndex);

    thumbSwiper?.slideTo(imageIndex);

}

  }

};

document.addEventListener("DOMContentLoaded", () => {
  window.initializeProductGallery?.();
});

/* ================= PRODUCT IMAGE LIGHTBOX ================= */
/* Click the main gallery image to see it full-size. Vanilla, no
   library — reads data-zoom-src (a larger rendition rendered
   server-side) and data-zoom-index off whichever slide was clicked, so
   it works regardless of which image in the gallery you're on. */
window.initializeProductLightbox = function () {
  const lightbox = document.getElementById('PdpLightbox');
  if (!lightbox) return;
  if (lightbox.dataset.lightboxBound) return;
  lightbox.dataset.lightboxBound = 'true';

  const lightboxImg = document.getElementById('PdpLightboxImage');
  const overlayEls = lightbox.querySelectorAll('[data-lightbox-close]');
  const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  const nextBtn = lightbox.querySelector('[data-lightbox-next]');

  let previouslyFocused = null;

  function getTriggers() {
    return Array.from(document.querySelectorAll('[data-zoom-trigger]'));
  }

  function showIndex(index) {
    const triggers = getTriggers();
    if (!triggers.length) return;

    const clamped = (index + triggers.length) % triggers.length;
    const trigger = triggers[clamped];

    lightboxImg.src = trigger.dataset.zoomSrc;
    lightboxImg.alt = trigger.querySelector('img')?.alt || '';
    lightbox.dataset.currentIndex = String(clamped);
  }

  function openLightbox(index) {
    previouslyFocused = document.activeElement;
    showIndex(index);
    lightbox.removeAttribute('inert');
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      lightbox.querySelector('.x-pdp-lightbox__close')?.focus();
    });
  }

  function closeLightbox() {
    lightbox.classList.remove('active');
    lightbox.setAttribute('inert', '');
    document.body.style.overflow = '';

    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
    previouslyFocused = null;
  }

  // Delegated — the gallery re-renders on variant change (section
  // reload), so triggers can't be bound directly once at page load.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-zoom-trigger]');
    if (trigger) {
      openLightbox(Number(trigger.dataset.zoomIndex) || 0);
    }
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('[data-zoom-trigger]');
    if (!trigger) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openLightbox(Number(trigger.dataset.zoomIndex) || 0);
    }
  });

  overlayEls.forEach((el) => el.addEventListener('click', closeLightbox));

  prevBtn?.addEventListener('click', () => {
    showIndex((Number(lightbox.dataset.currentIndex) || 0) - 1);
  });

  nextBtn?.addEventListener('click', () => {
    showIndex((Number(lightbox.dataset.currentIndex) || 0) + 1);
  });

  document.addEventListener('keydown', (event) => {
    if (!lightbox.classList.contains('active')) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      closeLightbox();
    } else if (event.key === 'ArrowLeft' && prevBtn) {
      showIndex((Number(lightbox.dataset.currentIndex) || 0) - 1);
    } else if (event.key === 'ArrowRight' && nextBtn) {
      showIndex((Number(lightbox.dataset.currentIndex) || 0) + 1);
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  window.initializeProductLightbox?.();
});

/* ================= HEADER SEARCH PANEL ================= */
/* Both header search icons used to be plain links straight to /search —
   clicking either one navigated away from whatever page the shopper was
   on. Intercepts that click and opens an in-page panel instead, with
   live results as they type (Shopify's real predictive search endpoint,
   /search/suggest.json, not the /recommendations one used elsewhere).
   The links keep their real href as a no-JS fallback — if this script
   fails to load, search still works exactly as it did before. */
window.initializeSearchPanel = function () {
  var panel = document.getElementById('SearchPanel');
  if (!panel) return;
  if (panel.dataset.searchBound) return;
  panel.dataset.searchBound = 'true';

  var input = document.getElementById('SearchPanelInput');
  var resultsEl = document.getElementById('SearchPanelResults');
  var closeEls = panel.querySelectorAll('[data-search-close]');

  var previouslyFocused = null;
  var debounceTimer = null;
  var currentController = null;

  function openPanel() {
    previouslyFocused = document.activeElement;
    panel.removeAttribute('inert');
    panel.classList.add('active');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { input.focus(); });
  }

  function closePanel() {
    panel.classList.remove('active');
    panel.setAttribute('inert', '');
    document.body.style.overflow = '';
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
    previouslyFocused = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-search-trigger]');
    if (trigger) {
      event.preventDefault();
      openPanel();
    }
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closePanel);
  });

  document.addEventListener('keydown', function (event) {
    if (!panel.classList.contains('active')) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      closePanel();
    }
  });

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  // Unlike the Ajax Cart API (which uses integer cents), the predictive
  // search JSON API returns price/compare_at_price fields as decimal
  // strings already in the shop's currency (e.g. "115.00") — no /100
  // conversion needed here.
  function formatMoney(value) {
    var amount = Number(value) || 0;
    var hasCents = amount % 1 !== 0;
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  // Same markup/classes as snippets/product-item.liquid (.prod-card),
  // built client-side instead of via Liquid: /search/suggest.json is a
  // pure JSON API and doesn't support the section_id server-render
  // pattern used elsewhere in this theme (confirmed — the response
  // never includes a `sections` key regardless of that param), so
  // there's no Liquid render path available for these results.
  function buildCard(product) {
    var image = product.featured_image || {};
    var imageUrl = image.url || product.image || '';
    var materialLabel = (product.tags || [])
      .filter(function (tag) { return /^material-|^metal-/i.test(tag); })
      .map(function (tag) { return tag.replace(/^material-|^metal-/i, '').trim(); })
      .join(' · ');

    var onSale = Number(product.compare_at_price_max) > Number(product.price);
    var priceHtml = onSale
      ? '<s class="compare">' + formatMoney(product.compare_at_price_max) + '</s><span class="current">' + formatMoney(product.price) + '</span>'
      : '<span class="current">' + formatMoney(product.price) + '</span>';

    var card = document.createElement('a');
    card.href = product.url;
    card.className = 'prod-card';
    card.innerHTML =
      '<div class="thumb">' +
        (imageUrl ? '<img class="thumb-img thumb-img--base" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(image.alt || product.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="name">' + escapeHtml(product.title) + '</div>' +
      '<div class="material">' + escapeHtml(materialLabel) + '</div>' +
      '<div class="price-cta-row"><div class="price-row">' + priceHtml + '</div></div>';
    return card;
  }

  function renderViewAllLink(query, count) {
    var link = document.createElement('a');
    link.className = 'x-search__view-all';
    link.href = window.Shopify.routes.root + 'search?q=' + encodeURIComponent(query) + '&type=product';
    link.textContent = count > 0
      ? 'View all results for “' + query + '”'
      : 'See full search results for “' + query + '”';
    resultsEl.appendChild(link);
  }

  function fetchResults(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    var url = window.Shopify.routes.root +
      'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6';

    fetch(url, { signal: currentController.signal })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        resultsEl.innerHTML = '';

        if (products.length > 0) {
          var grid = document.createElement('div');
          grid.className = 'prod-grid x-search__grid';
          products.forEach(function (product) {
            grid.appendChild(buildCard(product));
          });
          resultsEl.appendChild(grid);
        } else {
          var empty = document.createElement('p');
          empty.className = 'x-search__empty';
          empty.textContent = 'No results found.';
          resultsEl.appendChild(empty);
        }

        renderViewAllLink(query, products.length);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          console.error('Error loading search results:', error);
        }
      });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () { fetchResults(query); }, 300);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  window.initializeSearchPanel?.();
});

/* ================= HOMEPAGE SCROLL REVEAL ================= */
/* Each homepage section fades/rises into view the first time it's
   scrolled to. Scoped to body.template-index only — every other
   template is untouched. Skips the first section (the hero): it's
   already visible on load, so animating it in would only risk a flash
   of invisible content if this runs even slightly late, not a real
   scroll-triggered reveal. Respects prefers-reduced-motion by not
   running at all in that case — CSS already renders everything fully
   visible with no animation, this just avoids wiring up an observer
   that would never need to add/remove a class either way. */
window.initializeScrollReveal = function () {
  if (!document.body.classList.contains('template-index')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
  sections.shift();
  if (!sections.length) return;

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  sections.forEach(function (section) { observer.observe(section); });
};

document.addEventListener('DOMContentLoaded', function () {
  window.initializeScrollReveal?.();
});

/* ================= PDP "COMPLETE THE STACK" (cross-sell) ================= */
/* Same mechanism as sections/product-recommendations.liquid ("You may
   also like") and the cart drawer's recommendations — Shopify only
   populates recommendations.products when a section is fetched through
   its dedicated endpoint, not on a normal render. Requests
   intent=complementary first (real cross-sell "pairs with" signal);
   falls back to the default intent if that comes back empty (needs
   real order co-occurrence data this store may not have much of yet
   for every product) — same fallback already proven out on the cart
   drawer's recommendations. */
window.initializeCompleteTheStack = function () {
  var container = document.getElementById('CompleteTheStack');
  if (!container || !window.productId) return;
  if (container.dataset.stackLoaded) return;
  container.dataset.stackLoaded = 'true';

  function fetchStack(intent) {
    var url = window.Shopify.routes.root +
      'recommendations/products?section_id=complete-the-stack&limit=4&product_id=' +
      window.productId;
    if (intent) url += '&intent=' + intent;

    return fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        return temp.querySelector('.complete-the-stack');
      });
  }

  fetchStack('complementary')
    .then(function (section) {
      if (section) return section;
      return fetchStack();
    })
    .then(function (section) {
      if (section) container.replaceWith(section);
    })
    .catch(function (error) {
      console.error('Error loading Complete the Stack:', error);
    });
};

document.addEventListener("DOMContentLoaded", () => {
  window.initializeCompleteTheStack?.();
});

/* ================= HEADER: mobile drawer overlay / close ================= */
document.addEventListener("DOMContentLoaded", function () {
  var toggler = document.getElementById("mobileMenuToggler");
  var navCell = document.getElementById("siteNavDrawer");
  var overlay = document.getElementById("drawerOverlay");
  var closeBtn = document.getElementById("drawerClose");

  if (!toggler || !navCell || !overlay) return;

  function syncDrawerState() {
    var isOpen = navCell.classList.contains("active");
    overlay.classList.toggle("is-open", isOpen);
    toggler.setAttribute("aria-expanded", isOpen ? "true" : "false");
    document.body.style.overflow = isOpen ? "hidden" : "";
  }

  function closeDrawer() {
    navCell.classList.remove("active");
    syncDrawerState();
  }

  // theme bundle already toggles the "active" class on click of #mobileMenuToggler —
  // this listener is attached after that one runs, so it just mirrors the resulting state.
  toggler.addEventListener("click", syncDrawerState);
  overlay.addEventListener("click", closeDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

  // exclude the has-submenu top-level links: on mobile the bundle uses their first
  // click to reveal the submenu rather than navigate, so they must not close the drawer.
  navCell
    .querySelectorAll(".main-header__menu > li:not(.has-submenu) > a, .menu__submenu a, .drawer-icons a")
    .forEach(function (a) {
      a.addEventListener("click", closeDrawer);
    });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && navCell.classList.contains("active")) closeDrawer();
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth >= 1024 && navCell.classList.contains("active")) closeDrawer();
  });
});

/* ================= FILM: mute/unmute toggle ================= */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-film-mute]").forEach(function (btn) {
    var video = btn.closest(".film-hero")?.querySelector("video");
    if (!video) return;
    btn.addEventListener("click", function () {
      video.muted = !video.muted;
      btn.textContent = video.muted ? "Unmute" : "Mute";
    });
  });
});

/* ================= HERO: mobile auto-rotating slider ================= */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-hero-panels]").forEach(function (panelsEl) {
    var hero = panelsEl.closest(".zadeh-hero");
    var panels = Array.prototype.slice.call(panelsEl.querySelectorAll(".zadeh-hero__panel"));
    var dots = hero
      ? Array.prototype.slice.call(hero.querySelectorAll("[data-hero-dots] .zadeh-hero__dot"))
      : [];

    if (panels.length < 2) return;

    var current = 0;
    var intervalMs = parseInt(panelsEl.getAttribute("data-autoplay"), 10) || 5000;
    var timer = null;
    var isMobile = function () { return window.innerWidth < 768; };

    function show(index) {
      current = (index + panels.length) % panels.length;
      panels.forEach(function (p, i) { p.classList.toggle("is-active", i === current); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === current); });
    }

    function next() { show(current + 1); }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile()) return;
      timer = setInterval(next, intervalMs);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        show(i);
        startAutoplay();
      });
    });

    var touchStartX = null;
    panelsEl.addEventListener("touchstart", function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    panelsEl.addEventListener("touchend", function (e) {
      if (touchStartX === null || !isMobile()) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) < 40) return;
      show(dx < 0 ? current + 1 : current - 1);
      startAutoplay();
    }, { passive: true });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(startAutoplay, 200);
    });

    startAutoplay();
  });
});

/* ================= TRUST ROW — mobile icon-strip caption cycle ================= */
/* Below 1000px the trust row shows all icons in a single row with one
   shared caption underneath (see .trust-grid / .trust-copy in
   custom-nw.css) instead of a horizontal swiper or a cramped grid. This
   cycles which item's caption is shown/active. Above 1000px every
   item's copy is already shown inline by CSS regardless of .is-active,
   so this runs harmlessly there too — no separate desktop guard needed.
   Respects prefers-reduced-motion by showing the first item's caption
   with no auto-cycling at all. */
window.initializeTrustRowCycle = function () {
  var items = Array.from(document.querySelectorAll('.trustrow .trust-item'));
  if (items.length < 2) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery = window.matchMedia('(max-width: 1000px)');
  var timer = null;
  var index = 0;

  function show(i) {
    items.forEach(function (item, n) {
      item.classList.toggle('is-active', n === i);
    });
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  function start() {
    stop();
    show(index);
    if (reduceMotion || !mobileQuery.matches) return;
    timer = setInterval(function () {
      index = (index + 1) % items.length;
      show(index);
    }, 3200);
  }

  start();
  mobileQuery.addEventListener('change', start);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
};

document.addEventListener('DOMContentLoaded', function () {
  window.initializeTrustRowCycle?.();
});

/* ================= BFCACHE RESTORE — close any overlay left open ================= */
/* Chrome/Firefox can restore a page from the back-forward cache (bfcache)
   exactly as it was left, JS state included. Submitting a search from
   the header's instant-search panel navigates to /search without ever
   calling closePanel() — the panel just gets frozen "open" (.active,
   body scroll locked) on the page being left. Hit the browser's Back
   button afterwards and that frozen state comes back as-is: the panel's
   white background reappears pinned under the header, sitting over
   whatever's below it (the hero, on the homepage), until something
   closes it again. Same risk applies to the mobile nav drawer and the
   PDP image lightbox — same "leave mid-navigation" gap, same fix.
   pageshow with event.persisted===true is the standard signal a page
   came from bfcache rather than a fresh load; force every overlay closed
   and scrolling unlocked at that point. */
window.addEventListener('pageshow', function (event) {
  if (!event.persisted) return;

  var searchPanel = document.getElementById('SearchPanel');
  if (searchPanel && searchPanel.classList.contains('active')) {
    searchPanel.classList.remove('active');
    searchPanel.setAttribute('inert', '');
  }

  var navDrawer = document.getElementById('siteNavDrawer');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var toggler = document.getElementById('mobileMenuToggler');
  if (navDrawer && navDrawer.classList.contains('active')) {
    navDrawer.classList.remove('active');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    if (toggler) toggler.setAttribute('aria-expanded', 'false');
  }

  var lightbox = document.getElementById('PdpLightbox');
  if (lightbox && lightbox.classList.contains('active')) {
    lightbox.classList.remove('active');
    lightbox.setAttribute('inert', '');
  }

  document.body.style.overflow = '';
});

/* ================= PDP STICKY GALLERY OFFSET ================= */
/* The sticky header (#shopify-section-header — topbar + main nav, see
   layout.theme.css.liquid) isn't a fixed height: the announcement bar
   can be toggled off, and header padding changes at the 64em breakpoint.
   Rather than hardcode a top offset for the sticky product gallery
   (.product__image-cell, see custom-nw.css), measure the header's real
   rendered height and hand it to the CSS as a custom property so the
   gallery always sticks directly under it, at any screen size. */
function setPdpStickyOffset(){
  var headerEl = document.getElementById('shopify-section-header');
  var offset = headerEl ? headerEl.getBoundingClientRect().height : 90;

  /* Published unconditionally (not just on the PDP): the hide-on-scroll rule
     in custom-nw.css offsets the header by its own height, and that's needed
     on every template. Height is unaffected by the offset itself — only `top`
     changes — so this stays accurate whether the header is shown or hidden. */
  document.documentElement.style.setProperty('--header-h', offset + 'px');

  var imageCell = document.querySelector('.product__image-cell');
  if (!imageCell) return;
  document.documentElement.style.setProperty('--pdp-sticky-offset', offset + 'px');
}
window.addEventListener('load', setPdpStickyOffset);
window.addEventListener('resize', setPdpStickyOffset);
document.addEventListener('DOMContentLoaded', setPdpStickyOffset);
document.addEventListener('shopify:section:load', setPdpStickyOffset);

/* ================= HEADER — HIDE ON SCROLL DOWN (desktop) ================= */
/* Standard "reveal on scroll up" behaviour, desktop only. On mobile the
   header is short and holds the hamburger, so a bar that comes and goes
   costs more than the space it saves.

   Hiding is a CSS transform on .main-header (see custom-nw.css), not a
   change to position/top — the sticky positioning and document flow stay
   exactly as they are, so nothing below shifts.

   Note this deliberately does NOT feed back into --pdp-sticky-offset above:
   the product gallery stays anchored below the header's full height whether
   the header is showing or not. Re-measuring on every hide/show would make
   the sticky image jump around while scrolling, which is worse than the
   ~90px of headroom it would reclaim. */
(function () {
  var DESKTOP   = '(min-width: 64em)';
  var REVEAL_AT = 140; // px from the top; above this the header always shows
  var JITTER    = 6;   // ignore trackpad / sub-pixel noise below this delta

  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var ticking = false;

  function overlayOpen() {
    if (document.body.classList.contains('popup-open')) return true;
    var search = document.getElementById('SearchPanel');
    if (search && search.classList.contains('active')) return true;
    var nav = document.getElementById('siteNavDrawer');
    if (nav && nav.classList.contains('active')) return true;
    return false;
  }

  function showHeader() { document.body.classList.remove('header-hidden'); }
  function hideHeader() { document.body.classList.add('header-hidden'); }

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (!window.matchMedia(DESKTOP).matches || overlayOpen() || y <= REVEAL_AT) {
      showHeader();
      lastY = y;
      return;
    }

    var delta = y - lastY;
    // Leave lastY alone below the threshold so slow, deliberate scrolling
    // still accumulates into a decision instead of being discarded.
    if (Math.abs(delta) < JITTER) return;

    if (delta > 0) { hideHeader(); } else { showHeader(); }
    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // A keyboard user tabbing into the nav must never be chasing a hidden bar.
  document.addEventListener('focusin', function (e) {
    var header = document.querySelector('.main-header');
    if (header && header.contains(e.target)) showHeader();
  });

  // Restoring from bfcache keeps the old class but not the old scroll state.
  window.addEventListener('pageshow', function () {
    lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    showHeader();
  });
})();
